export default __webpack_public_path__ + "static/media/icon-statistics.c50e7dcb.svg";